import React from "react";
import { useAppContext } from "../../AppProvider.jsx";
import ButtonUtility from "../../Components/Buttons/Utility.tsx";
import ButtonDelete from "../../Components/Buttons/Delete.tsx";
import { useShipmentDeleteContext } from "./providers/hooks.ts";

const ShipmentDelete = () => {
  const { data, callback, deleteShipments, loader } =
    useShipmentDeleteContext();
  const { dictionary } = useAppContext();

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col text-center">
          <label>
            {data?.length && data.length > 1
              ? dictionary.messages.ask_to_delete_selected
              : dictionary.messages.ask_to_delete}
          </label>
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (callback) {
              callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonDelete
          className="w-50"
          onClick={() => deleteShipments()}
          disabled={loader}
          loading={loader}
        >
          {dictionary.actions.delete}
        </ButtonDelete>
      </div>
    </React.Fragment>
  );
};
export default ShipmentDelete;
